import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import AuthLayout from "../Components/Common/AuthLayout";
import ajaxUser from "../util/remote/ajaxUser";
import functions from "../util/functions";

const LoginPage = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const loginUser = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password) {
      return toast.error("Enter your username and password.");
    }

    setLoading(true);
    const res = await ajaxUser.loginUser(username.trim(), password);
    setLoading(false);

    if (res.status !== "OK") {
      return toast.error(res.message || "Those details were not recognised.");
    }

    localStorage.setItem("projectm@user", res.details);

    // An account still on the password it was created with has to choose one
    // before it goes any further.
    if (!functions.hasChosenPassword()) {
      navigate("/activate", { replace: true });
      return;
    }

    navigate("/", { replace: true });
    window.location.reload();
  };

  return (
    <AuthLayout
      title="Welcome back"
      subtitle="Sign in to pick up where you left off."
      footer={
        <>
          Trouble signing in? Speak to your administrator.
        </>
      }
    >
      <form onSubmit={loginUser}>
        <div className="auth-field">
          <label htmlFor="login-username">Username</label>
          <div className="auth-input-wrap">
            <input
              id="login-username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Type your username"
              autoComplete="username"
              autoFocus
            />
          </div>
        </div>

        <div className="auth-field">
          <label htmlFor="login-password">Password</label>
          <div className="auth-input-wrap">
            <input
              id="login-password"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Type your password"
              autoComplete="current-password"
            />
            <button
              type="button"
              className="auth-reveal"
              onClick={() => setShowPassword((s) => !s)}
              title={showPassword ? "Hide password" : "Show password"}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              <i className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
            </button>
          </div>
          <Link className="auth-inline-link" to="/forgot-password">
            Forgot password?
          </Link>
        </div>

        <button type="submit" className="auth-submit" disabled={loading}>
          {loading ? "Signing in…" : "Log In"}
        </button>
      </form>
    </AuthLayout>
  );
};

export default LoginPage;
